(function () {
  var TILE_SELECTOR = '.product-tile_index';
  var DESKTOP_MEDIA = window.matchMedia('(min-width: 992px)');

  function matchProductTileHeights() {
    var tiles = Array.from(document.querySelectorAll(TILE_SELECTOR));
    if (!tiles.length) return;

    tiles.forEach(function (el) {
      el.style.height = '';
    });

    var currentTop = null;
    var rowItems = [];

    function flushRow() {
      if (!rowItems.length) return;
      var maxH = Math.max.apply(
        null,
        rowItems.map(function (el) {
          return el.offsetHeight;
        })
      );
      rowItems.forEach(function (el) {
        el.style.height = maxH + 'px';
      });
      rowItems = [];
    }

    tiles.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (currentTop === null) {
        currentTop = top;
      }
      if (Math.abs(top - currentTop) > 1) {
        flushRow();
        currentTop = top;
      }
      rowItems.push(el);
    });

    flushRow();
  }

  function initHoverBackgrounds() {
    var productTiles = document.querySelectorAll(TILE_SELECTOR);

    productTiles.forEach(function (tile) {
      var hoverImageUrl = tile.getAttribute('data-hover');
      if (hoverImageUrl) {
        var img = new Image();
        img.src = hoverImageUrl;
      }
    });

    function setBackground(e) {
      if (!DESKTOP_MEDIA.matches) return;
      var tile = e.currentTarget;
      var hoverImage = tile.getAttribute('data-hover');
      if (!hoverImage) return;
      tile.style.backgroundImage = "url('" + hoverImage + "')";
    }

    function revertBackground(e) {
      e.currentTarget.style.removeProperty('background-image');
    }

    productTiles.forEach(function (tile) {
      tile.addEventListener('mouseenter', setBackground);
      tile.addEventListener('mouseleave', revertBackground);
    });
  }

  function init() {
    initHoverBackgrounds();
    matchProductTileHeights();
  }

  var debouncedMatch =
    typeof debounce === 'function'
      ? debounce(matchProductTileHeights, 150)
      : matchProductTileHeights;

  function bindFlavoursCarousels() {
    document.querySelectorAll('.jc-home-flavours__carousel').forEach(function (carousel) {
      if (carousel.dataset.heightsBound === 'true') return;

      var splide = window.slideshows && window.slideshows[carousel.id];
      if (!splide) return;

      carousel.dataset.heightsBound = 'true';
      splide.on('mounted', matchProductTileHeights);
      splide.on('updated', matchProductTileHeights);
      splide.on('resize', matchProductTileHeights);
      matchProductTileHeights();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    setTimeout(function () {
      bindFlavoursCarousels();
      matchProductTileHeights();
    }, 100);
    setTimeout(function () {
      bindFlavoursCarousels();
      matchProductTileHeights();
    }, 500);
    window.addEventListener('load', function () {
      bindFlavoursCarousels();
      matchProductTileHeights();
    });
  });

  window.addEventListener('resize', debouncedMatch);
})();
